var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "shopMain" },
    [
      false && _vm.shopInfo && _vm.shopInfo.specificationId != 0
        ? _c("BuyNowButton", {
            attrs: { shopInfo: _vm.shopInfo ? _vm.shopInfo : {} }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        [_c("BaseFullScreenAnimation", { ref: "baseFullScreenAnimation" })],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "header" },
        [
          _c("HeaderAddress", { attrs: { shopId: _vm.shopId } }, [
            _c(
              "div",
              { staticClass: "searchIconWrapper" },
              [
                _c("SearchIcon", {
                  nativeOn: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.$router.push({
                        path: "/shopSearch?shopId=" + _vm.shopId
                      })
                    }
                  }
                })
              ],
              1
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "swipe-up",
              rawName: "v-swipe-up",
              value: _vm.swipeUp,
              expression: "swipeUp"
            },
            {
              name: "swipe-down",
              rawName: "v-swipe-down",
              value: _vm.swipeDown,
              expression: "swipeDown"
            }
          ],
          staticClass: "contentWrapper"
        },
        [
          _c(
            "div",
            { ref: "topContent", staticClass: "topContent" },
            [
              _c(
                "div",
                {
                  ref: "warningAndshopDescription",
                  staticClass: "warningAndshopDescription"
                },
                [
                  _vm.ifShowHeaderWarning
                    ? [
                        _c("div", { staticClass: "headerWarning" }, [
                          _vm._v("不支持配送到当前地址")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "horizonGully" })
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _c("BriefShopInfo")
                ],
                2
              ),
              _vm._v(" "),
              _vm.shopInfo
                ? _c(
                    "van-swipe",
                    {
                      staticStyle: { "flex-shrink": "0" },
                      attrs: { autoplay: 3000 }
                    },
                    _vm._l(_vm.shopInfo.shopBroadcastPictures, function(
                      item,
                      index
                    ) {
                      return _c("van-swipe-item", { key: index }, [
                        _c("img", {
                          staticStyle: {
                            width: "100%",
                            height: "calc(100vw * 246 / 750)"
                          },
                          attrs: {
                            loading: "lazy",
                            src: _vm.getImgUrl(item.picture[0])
                          },
                          on: {
                            click: function($event) {
                              return _vm.urlLocate(item.url)
                            }
                          }
                        })
                      ])
                    }),
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              ref: "compositionContentTab",
              staticClass: "compositionContentTab"
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    width: "100%",
                    "box-sizing": "border-box",
                    display: "flex",
                    "justify-content": "space-around"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      on: {
                        click: function($event) {
                          return _vm.clickActiveCompositionContentTab(
                            "productAll",
                            true
                          )
                        }
                      }
                    },
                    [_vm._v("\n                    全部商品\n                ")]
                  ),
                  _vm._v(" "),
                  false
                    ? _c(
                        "div",
                        {
                          on: {
                            click: function($event) {
                              return _vm.clickActiveCompositionContentTab(
                                "productCategory",
                                true
                              )
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                    商品分类\n                "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      on: {
                        click: function($event) {
                          return _vm.clickActiveCompositionContentTab(
                            "comment",
                            true
                          )
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "center"
                          }
                        },
                        [
                          _c("span", [_vm._v("评价")]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.lodash.round(_vm.shopInfo.scoring, 1))
                            )
                          ])
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      on: {
                        click: function($event) {
                          return _vm.clickActiveCompositionContentTab(
                            "shop",
                            true
                          )
                        }
                      }
                    },
                    [_vm._v("\n                    商家\n                ")]
                  )
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "horizonGully" }),
              _vm._v(" "),
              _c("div", {
                ref: "stickyCompositionContentTabBottomLine",
                staticClass: "stickyCompositionContentTabBottomLine"
              })
            ]
          ),
          _vm._v(" "),
          _c("div", {
            staticClass: "horizonGully",
            staticStyle: { "flex-shrink": "0" }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              ref: "contentCompositionWrapper",
              staticClass: "contentCompositionWrapper"
            },
            [
              _c("BaseFadeTransition", { attrs: { ifCrossFade: true } }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.activeCompositionContentTab == "productAll",
                        expression:
                          "activeCompositionContentTab == 'productAll'"
                      }
                    ],
                    staticClass: "contentCompositionProductAllWrapper"
                  },
                  [
                    _c(
                      "BaseScroll",
                      {
                        ref: "contentCompositionProductAllTypeScroll",
                        staticClass: "categoryItemList",
                        attrs: { ifScrollHorizon: true, showLoading: false },
                        on: { scrollTop: _vm.productListAllTypeScrollTop }
                      },
                      [
                        _c(
                          "div",
                          {
                            ref: "productAllSideType_all",
                            class: {
                              categoryItemActive: _vm.ifShowAllProductList,
                              categoryItem: !_vm.ifShowAllProductList
                            },
                            on: { click: _vm.showAllProduct }
                          },
                          [
                            _c("div", { staticClass: "title" }, [
                              _vm._v("所有商品")
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "number" }, [
                              _vm._v(_vm._s(_vm.productPurchaseTotalNumber))
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _vm._l(_vm.category, function(item, index) {
                          return _c(
                            "div",
                            {
                              key: "category" + index,
                              ref: "productAllSideType_" + index,
                              refInFor: true,
                              class: {
                                categoryItemActive:
                                  _vm.ifShowAllProductList == false &&
                                  _vm.activeProductTypeIndex == index,
                                categoryItem:
                                  _vm.ifShowAllProductList == true ||
                                  _vm.activeProductTypeIndex != index
                              },
                              on: {
                                "!click": function($event) {
                                  $event.stopPropagation()
                                  return _vm.clickProductTypeSidebar(index)
                                }
                              }
                            },
                            [
                              _c("div", { staticClass: "title" }, [
                                _vm._v(_vm._s(item.productTypeName))
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "number" }, [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.productTypeStatistic[
                                        item.productTypeId
                                      ]
                                        ? _vm.productTypeStatistic[
                                            item.productTypeId
                                          ]
                                        : ""
                                    ) +
                                    "\n                            "
                                )
                              ])
                            ]
                          )
                        }),
                        _vm._v(" "),
                        _c("div", {
                          ref: "productAllTypeBottomLine",
                          staticClass: "productAllTypeBottomLine"
                        })
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "BaseScroll",
                      {
                        directives: [
                          {
                            name: "swipe-left",
                            rawName: "v-swipe-left",
                            value: _vm.productAllSwipeLeft,
                            expression: "productAllSwipeLeft"
                          },
                          {
                            name: "swipe-right",
                            rawName: "v-swipe-right",
                            value: _vm.productAllSwipeRight,
                            expression: "productAllSwipeRight"
                          }
                        ],
                        ref: "contentCompositionProductAllScroll",
                        staticStyle: {
                          width: "100%",
                          height: "100%",
                          "overflow-y": "auto",
                          "flex-grow": "1"
                        },
                        attrs: { showLoading: false },
                        on: { scrollTop: _vm.productListAllScrollTop }
                      },
                      [
                        _c(
                          "div",
                          _vm._l(_vm.productListWithTagAll, function(
                            ref,
                            index
                          ) {
                            var pId = ref.pId
                            var priceType = ref.priceType
                            var pName = ref.pName
                            var pPic1 = ref.pPic1
                            var pNowPrice = ref.pNowPrice
                            var pOriginalPrice = ref.pOriginalPrice
                            var distance = ref.distance
                            var transportationMode = ref.transportationMode
                            var transportationDescriptionList =
                              ref.transportationDescriptionList
                            var specificationList = ref.specificationList
                            var shelfIdList = ref.shelfIdList
                            return _c(
                              "div",
                              {
                                key:
                                  "productAll_" +
                                  (_vm.ifShowAllProductList
                                    ? "all"
                                    : _vm.activeProductTypeIndex) +
                                  "_" +
                                  pId,
                                class: {
                                  productOfProductAllLeft: index % 2 == 0,
                                  productOfProductAllRight: index % 2 != 0
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.goToProductDetail(
                                      _vm.shopId,
                                      pId
                                    )
                                  }
                                }
                              },
                              [
                                _c("ProductOfListBrief", {
                                  attrs: {
                                    shopId: _vm.shopId,
                                    productId: pId,
                                    distance: distance,
                                    transportationMode: transportationMode,
                                    transportationDescriptionList: transportationDescriptionList,
                                    priceType: priceType,
                                    productName: pName,
                                    productImg: pPic1,
                                    productPrice: pNowPrice,
                                    productOriginalPrice:
                                      specificationList.length > 1
                                        ? -1
                                        : pOriginalPrice,
                                    specificationList: specificationList
                                  }
                                })
                              ],
                              1
                            )
                          }),
                          0
                        )
                      ]
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              false
                ? [
                    _c("BaseFadeTransition", { attrs: { ifCrossFade: true } }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.activeCompositionContentTab ==
                                "productCategory",
                              expression:
                                "\n                            activeCompositionContentTab == 'productCategory'\n                        "
                            }
                          ],
                          staticClass:
                            "contentCompositionProductCategoryWrapper"
                        },
                        [
                          _c(
                            "BaseScroll",
                            {
                              ref: "contentCompositionProductTypeScroll",
                              staticClass:
                                "contentCompositionProductTypeScroll",
                              attrs: { showLoading: false },
                              on: { scrollTop: _vm.productCategoryScrollTop }
                            },
                            [
                              _c(
                                "div",
                                { ref: "contentCompositionProductTypeContent" },
                                [
                                  _c(
                                    "van-sidebar",
                                    {
                                      ref: "contentCompositionProductType",
                                      model: {
                                        value: _vm.activeProductTypeIndex,
                                        callback: function($$v) {
                                          _vm.activeProductTypeIndex = $$v
                                        },
                                        expression: "activeProductTypeIndex"
                                      }
                                    },
                                    _vm._l(_vm.category, function(item, index) {
                                      return _c(
                                        "div",
                                        {
                                          key: "category" + index,
                                          on: {
                                            "!click": function($event) {
                                              $event.stopPropagation()
                                              return _vm.clickProductTypeSidebar(
                                                index
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("van-sidebar-item", {
                                            attrs: {
                                              title: item.productTypeName,
                                              badge: _vm.productTypeStatistic[
                                                item.productTypeId
                                              ]
                                                ? _vm.productTypeStatistic[
                                                    item.productTypeId
                                                  ]
                                                : ""
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    }),
                                    0
                                  )
                                ],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "BaseScroll",
                            {
                              ref: "contentCompositionProductListScroll",
                              staticClass:
                                "\n                                contentCompositionProductListScroll\n                            ",
                              attrs: { showLoading: false },
                              on: { scrollTop: _vm.productListScrollTop }
                            },
                            [
                              _c(
                                "div",
                                [
                                  _vm.interestedProductInfo
                                    ? _c(
                                        "div",
                                        [
                                          _c("ProductOfShop", {
                                            key:
                                              "interestedProductInfo_" +
                                              _vm.interestedProductInfo.pId,
                                            staticStyle: {
                                              background: "#ffffff"
                                            },
                                            attrs: {
                                              shopId: _vm.shopId,
                                              productId:
                                                _vm.interestedProductInfo.pId,
                                              productName:
                                                _vm.interestedProductInfo.pName,
                                              productNowPrice: parseFloat(
                                                _vm.interestedProductInfo.pNowPrice.toFixed(
                                                  2
                                                )
                                              ),
                                              productOriginalPrice: parseFloat(
                                                _vm.interestedProductInfo.pOriginalPrice.toFixed(
                                                  2
                                                )
                                              ),
                                              productNumOfSold: parseInt(
                                                _vm.interestedProductInfo
                                                  .pNumOfBuy
                                              ),
                                              productImg:
                                                _vm.interestedProductInfo
                                                  .pPic_1,
                                              specificationList:
                                                _vm.interestedProductInfo
                                                  .specificationList,
                                              shelfId:
                                                _vm.interestedProductInfo
                                                  .shelfId
                                            },
                                            nativeOn: {
                                              click: function($event) {
                                                return _vm.goToProductDetail(
                                                  _vm.shopId,
                                                  _vm.interestedProductInfo.pId
                                                )
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("div", {
                                            staticClass: "horizonGully"
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.productListNeedShowWithCagetoryId,
                                    function(ref, index) {
                                      var pId = ref.pId
                                      var pName = ref.pName
                                      var pNowPrice = ref.pNowPrice
                                      var pOriginalPrice = ref.pOriginalPrice
                                      var pNumOfBuy = ref.pNumOfBuy
                                      var pPic1 = ref.pPic1
                                      var specificationList =
                                        ref.specificationList
                                      var shelfIdList = ref.shelfIdList
                                      var currentCategory = ref.currentCategory
                                      return _c(
                                        "div",
                                        {
                                          key:
                                            "ProductOfShop-" +
                                            pId +
                                            "-" +
                                            currentCategory,
                                          ref:
                                            "ProductOfShop-" +
                                            pId +
                                            "-" +
                                            currentCategory,
                                          refInFor: true,
                                          attrs: {
                                            id: "productOfShopIndex_" + index
                                          }
                                        },
                                        [
                                          _c("ProductOfShop", {
                                            staticStyle: {
                                              width: "100%",
                                              background: "#ffffff"
                                            },
                                            attrs: {
                                              shopId: _vm.shopId,
                                              productId: pId,
                                              productName: pName,
                                              productNowPrice: parseFloat(
                                                pNowPrice.toFixed(2)
                                              ),
                                              productOriginalPrice: parseFloat(
                                                pOriginalPrice.toFixed(2)
                                              ),
                                              productNumOfSold: parseInt(
                                                pNumOfBuy
                                              ),
                                              productImg: pPic1,
                                              specificationList: specificationList,
                                              shelfId: shelfIdList
                                            },
                                            nativeOn: {
                                              click: function($event) {
                                                return _vm.goToProductDetail(
                                                  _vm.shopId,
                                                  pId
                                                )
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("div", {
                                            staticStyle: { height: "10px" }
                                          })
                                        ],
                                        1
                                      )
                                    }
                                  )
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c("div", {
                                ref: "contentCompositionProductListPadding",
                                staticStyle: { height: "0px" }
                              })
                            ]
                          )
                        ],
                        1
                      )
                    ])
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c("BaseFadeTransition", { attrs: { ifCrossFade: true } }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.activeCompositionContentTab == "comment",
                        expression: "activeCompositionContentTab == 'comment'"
                      }
                    ],
                    staticClass: "contentCompositionCommentWrapper"
                  },
                  [
                    _c(
                      "BaseScroll",
                      {
                        ref: "contentCompositionCommentListScroll",
                        staticStyle: { width: "100%", height: "100%" },
                        on: { pullingUp: _vm.commentListPullingUp }
                      },
                      [
                        _c(
                          "div",
                          {
                            ref: "contentCompositionCommentListContent",
                            staticStyle: { width: "100%", height: "100%" }
                          },
                          [
                            _vm.commentList.records.length > 0
                              ? _vm._l(_vm.commentList.records, function(
                                  ref,
                                  index
                                ) {
                                  var user = ref.user
                                  var evaluationUserPetName =
                                    ref.evaluationUserPetName
                                  var evaluationOfGoodsTime =
                                    ref.evaluationOfGoodsTime
                                  var evaluationOfGoodsMsg =
                                    ref.evaluationOfGoodsMsg
                                  var productName = ref.productName
                                  return _c(
                                    "div",
                                    {
                                      key: "comment" + index,
                                      staticStyle: {
                                        "box-sizing": "border-box",
                                        padding: "10px"
                                      }
                                    },
                                    [
                                      _c("Comment", {
                                        attrs: {
                                          wxAvatar: user ? user.wxAvatar : null,
                                          evaluationUserPetName: evaluationUserPetName,
                                          evaluationOfGoodsTime: evaluationOfGoodsTime,
                                          evaluationOfGoodsMsg: evaluationOfGoodsMsg,
                                          productName: productName
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                index !==
                                                _vm.commentList.records.length -
                                                  1,
                                              expression:
                                                "\n                                            index !==\n                                            commentList.records.length -\n                                                1\n                                        "
                                            }
                                          ]
                                        },
                                        [
                                          _c("div", {
                                            staticClass: "horizonDivider"
                                          })
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                })
                              : [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "\n                                        commentNoData\n                                    "
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    暂无数据\n                                "
                                      )
                                    ]
                                  )
                                ]
                          ],
                          2
                        )
                      ]
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("BaseFadeTransition", { attrs: { ifCrossFade: true } }, [
                _vm.activeCompositionContentTab == "shop"
                  ? _c(
                      "div",
                      {
                        staticClass: "contentCompositionShopWrapper",
                        staticStyle: {
                          "overflow-y": "auto",
                          "-webkit-overflow-scrolling": "touch"
                        }
                      },
                      [
                        _c("ShopInfo", {
                          ref: "shopInfo",
                          attrs: {
                            shopName: _vm.shopInfoDetail.shopName,
                            shopMobile: _vm.shopInfoDetail.linkMobilePhone,
                            shopAddress: _vm.shopInfoDetail.address,
                            shopPositionLongitude: _vm.shopInfoDetail.longitude,
                            shopPositionLatitude: _vm.shopInfoDetail.latitude,
                            shopCertificateImg:
                              _vm.shopInfoDetail.businessLicense,
                            shopFoodCertificateImg: _vm.shopInfoDetail.img
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ])
            ],
            2
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "bottomBar" }, [
        _c(
          "div",
          { staticClass: "\n              autoHorizonScroll  \n            " },
          [
            _c("BaseAutoHorizonScroll", {
              attrs: { text: _vm.bottomBarDescription }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "operatePanel" },
          [
            _c(
              "div",
              {
                staticClass: "homeIconWrapper",
                on: { click: _vm.goToMainPage }
              },
              [
                _c("i", { staticClass: "iconfont icon-home" }),
                _vm._v(" "),
                _c("div", { staticClass: "label" }, [_vm._v("首页")])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mineIconWrapper", on: { click: _vm.goToMine } },
              [
                _c("i", { staticClass: "iconfont icon-mine" }),
                _vm._v(" "),
                _c("div", { staticClass: "label" }, [_vm._v("我的")])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "mineIconWrapper",
                on: { click: _vm.contactCustomerService }
              },
              [
                _c("i", { staticClass: "iconfont icon-mine" }),
                _vm._v(" "),
                _c("div", { staticClass: "label" }, [_vm._v("客服")])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "cartIconWrapper",
                attrs: { id: "componentCartIcon" },
                on: { click: _vm.showCart }
              },
              [
                _c("i", { staticClass: "iconfont icon-home-cart" }),
                _vm._v(" "),
                _c("div", { staticClass: "label" }, [_vm._v("购物车")]),
                _vm._v(" "),
                _c("div", { staticClass: "prodNumber" }, [
                  _vm._v(_vm._s(_vm.cartProductTotalNumber))
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "totalPriceWrapper" }, [
              _vm._v(
                "\n                ￥" +
                  _vm._s(_vm.lodash.round(_vm.totalPrice, 2)) +
                  "\n            "
              )
            ]),
            _vm._v(" "),
            _vm.shopInfo.minimallyBuyPrice <= _vm.totalPrice &&
            _vm.shopInfo.ifBusiness == 0
              ? [
                  _c(
                    "div",
                    {
                      staticClass: "bottomButton",
                      on: { click: _vm.commitOrder }
                    },
                    [_vm._v(_vm._s(_vm.commitOrderText))]
                  )
                ]
              : [
                  _c(
                    "div",
                    {
                      staticClass: "bottomButton",
                      attrs: { disabled: "" },
                      on: { click: _vm.commitOrder }
                    },
                    [_vm._v(_vm._s(_vm.commitOrderText))]
                  )
                ]
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c("SharedIcon", {
        staticStyle: { right: "0", bottom: "4em" },
        nativeOn: {
          click: function($event) {
            return _vm.showShopShareView($event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }